export const LEVELS_TO_SHOW_USE_BLENDED_RATE = [
  'LocationRateSetting',
  'LocationPositionRateSetting',
  'MarketPositionRateSetting',
];

export const RATE_TYPE_RESTRICTED_RESOURCES = [
  'AgencyLocationRateSetting',
  'AgencyLocationPositionRateSetting',
  'LocationPositionRateSetting',
];

export const MARKUP_APPLICABLE_LEVELS = [
  'LocationRateSetting',
  'LocationPositionRateSetting',
  'StateRateSetting',
];
